<tt-page *ngIf="!!setting" class="col-xs-12 sp-0 height-full">
    <div class="col-xs-12 sp-0 height-full" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="selectionCriterias"></ng-container>
        </tt-card>

        <tt-grid *ngIf="!!grid" [(ttOptions)]="grid"></tt-grid>
    </div>

    <div class="height-full" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="custprodaccbcs_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="20">
                    <tt-card>
                        <ng-container *ngTemplateOutlet="selectionCriterias"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="80">
                    <tt-grid *ngIf="!!grid" [(ttOptions)]="grid"></tt-grid>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>

<ng-template #selectionCriterias>
    <ng-container *ngIf="!!setting">
        <tt-select ttRememberId="w_custprodaccbcs.businessco_no"
                   ttLabel="businessco"
                   [(ttModel)]="setting.businessco_no"
                   (ttModelChange)="onBusinesscoChanged($event)"
                   [ttData]="selectListCompanies"
                   ttDataId="businessco_no"
                   ttDataName="company_name"></tt-select>

        <tt-search ttLabel="account_name"
                   [(ttModel)]="setting.account_name"
                   [ttSearch]="searchAccountName"
                   (ttModelChange)="onAccountValueChanged($event, 'account_name')"
                   (ttOnSelected)="onAccountSelected($event, 'account_name')"
                   (ttOnClear)="onAccountCleared('account_name')"></tt-search>

        <tt-search ttLabel="account_name_free"
                   [(ttModel)]="setting.account_name_free"
                   [ttSearch]="searchAccountNameFree"
                   (ttModelChange)="onAccountValueChanged($event, 'account_name_free')"
                   (ttOnSelected)="onAccountSelected($event, 'account_name_free')"
                   (ttOnClear)="onAccountCleared('account_name_free')"></tt-search>

        <tt-search ttLabel="account_name_export"
                   [(ttModel)]="setting.account_name_export"
                   [ttSearch]="searchAccountNameExport"
                   (ttModelChange)="onAccountValueChanged($event, 'account_name_export')"
                   (ttOnSelected)="onAccountSelected($event, 'account_name_export')"
                   (ttOnClear)="onAccountCleared('account_name_export')"></tt-search>

        <tt-search ttLabel="account_name_free_export"
                   [(ttModel)]="setting.account_name_free_export"
                   [ttSearch]="searchAccountNameFreeExport"
                   (ttModelChange)="onAccountValueChanged($event, 'account_name_free_export')"
                   (ttOnSelected)="onAccountSelected($event, 'account_name_free_export')"
                   (ttOnClear)="onAccountCleared('account_name_free_export')"></tt-search>
    </ng-container>
</ng-template>
